import * as React from "react"
import { LogoSkeleton, LogoProps } from "./skeleton"

export function GraphcmsLogo(props: LogoProps) {
  return (
    <LogoSkeleton {...props} logoName="GraphcmsLogo">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3754 3.69695L11.1253 4.84238L8.87526 5.98766L6.62519 7.13309V14.0053L8.87526 12.8599L11.1253 11.7145V9.42375L8.87526 10.5691V8.27848L11.1253 7.13305L13.3754 5.98762V12.8599L11.1253 14.0053L8.87526 15.1506L6.62519 16.296L4.37524 17.4414L6.62532 18.5868L8.87539 17.4414L11.1255 16.2961L13.3755 15.1507L15.6256 14.0055V2.55168L13.3754 1.40625V3.69695Z"
        fill="black"
      />
    </LogoSkeleton>
  )
}
